module.exports = __webpack_public_path__ + "static/img/Tom-Opacic.1b803f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Tom-Opacic.jpg
// module id = WzE/
// module chunks = 0